import {create} from "zustand";

export const useScrollPercentage = create((set) => ({
    scrollPercentage: 0.0,
    currentSection: 0,
    setScrollPercentage: (sp, cs) => set(({scrollPercentage: sp, currentSection: cs})),
}))
